import { makeAutoObservable } from 'mobx';

class BulkJobInvitationNotificationStore {

  bulkJobInvitationSentNotificationVisible = false;

  setBulkJobInvitationSentNotificationVisible = (value) => {
    this.bulkJobInvitationSentNotificationVisible = value;
  };

  constructor() {
    makeAutoObservable(this);
  }

  showBulkJobInvitationSentNotification = () => {
    this.setBulkJobInvitationSentNotificationVisible(true);

    setTimeout(() => {
      this.setBulkJobInvitationSentNotificationVisible(false);
    }, 5000);
  };
}

export default new BulkJobInvitationNotificationStore();
